import { Component, inject } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { NovaIcon } from '@rds-nova/angular-icon';
import { TranslatePipe } from '@ngx-translate/core';
import { TrackedLinkDirective } from 'src/app/core/analytics/directives/tracked-link.directive';
import { FaqWidgetService } from '../../services/faq-widget.service';

@Component({
    selector: 'app-faq-menu-link',
  templateUrl: './faq-menu-link.component.html',
    styleUrl: './faq-menu-link.component.scss',
    imports: [MatMenuModule, NovaIcon, TranslatePipe, TrackedLinkDirective],
})
export class FaqMenuLinkComponent {
    faqWidgetService = inject(FaqWidgetService);
}
